import { qualifiesPossibleCatchmentSchool } from "../hooks/useSchoolListBuckets";
import { schoolQualifiesOpenToAll, statedOpenSeatLabel } from "../utils/openCatchmentAccess";

const POSSIBLE_MILES = 8;

/**
 * Same four standings as the map list, for one school and the current home.
 * Open shows the published open-seat count when the school states one.
 */
export function catchmentStanding(school, check, miles, { ready, hasHome } = {}) {
  if (!hasHome || !ready || !school) return { key: "", label: "—" };

  const category = String(school.catchment_category || "").trim().toLowerCase();
  if (check?.inCatchment && category !== "open") {
    return { key: "in", label: "In catchment" };
  }
  if (schoolQualifiesOpenToAll(school)) {
    const seats = statedOpenSeatLabel(school);
    return { key: "open", label: seats ? `Open · ${seats}` : "Open" };
  }
  const within = Number.isFinite(miles) && miles <= POSSIBLE_MILES;
  if (qualifiesPossibleCatchmentSchool(school) && within) {
    return { key: "possible", label: "Possible catchment" };
  }
  return { key: "out", label: "Not in catchment" };
}

const OFSTED_SORT = {
  outstanding: 1,
  good: 2,
  "requires improvement": 3,
  inadequate: 4,
};

export function ofstedSortValue(grade) {
  const key = String(grade || "").trim().toLowerCase();
  return OFSTED_SORT[key] ?? null;
}
